export const BENE_NAME_HELPER_TEXT = `Enter the recipient’s full name as per their bank records to avoid transfer delays or rejection. 
If the bank records use initials, enter the full name instead.`;

export const BENE_NAME_INCOMPLETE_HELPER_TEXT = `Please enter the full name. Incomplete names may need extra verification.`;

export const BENE_ADDRESS_HELPER_TEXT = `Based on recipient’s residential address`;

export const REMITTER_PERSONAL_FIELDS_ARRAY = [
  'beneficiary_name',
  'mobile_country_code',
  'mobile_number',
  'email',
  'country_code'
];

export const VALID_CHINA_NO_MSG = 'Please add a valid China mobile number.';
export const INR_BENE_CURRENCY_MSG = `Please make sure the mobile number is linked to 
the bank account else it will result in return of transaction.`;
export const KENYA_WALLET_MSG = `In case of wallet deposit, make sure the entered mobile number is registered with recipient’s wallet.`;
